import RootStore, { initializeStores } from './RootStore';

const rootStoreInstance = initializeStores();

const stores = rootStoreInstance.mobxStores;

export default stores;

export type { IStores } from './RootStore';